/**
 * Single source of truth for the automation-template TanStack Query cache keys.
 *
 * Every consumer (queries, mutations, manual invalidations, prefetches) must
 * import from this module so producer/consumer keys stay in lockstep. Inlining
 * a copy in another module would silently break invalidation if the shape ever
 * changes.
 */
export const templateKeys = {
  all: ['automationTemplates'] as const,
  lists: () => [...templateKeys.all, 'list'] as const,
  detail: (id: string) => [...templateKeys.all, 'detail', id] as const,
  /** Nested under detail so a template save, which clears auto-saves, refetches them too. */
  emailAutoSaves: (id: string) => [...templateKeys.detail(id), 'emailAutoSaves'] as const,
  defaultMetadata: () => [...templateKeys.all, 'defaultMetadata'] as const,
  /** GET /sync/status/:templateId — per-template active sync + sub-jobs */
  templateSyncStatus: (templateId: string) =>
    [...templateKeys.all, 'templateSyncStatus', templateId] as const,
  automationStatuses: (templateId: string) =>
    [...templateKeys.all, 'automationStatuses', templateId] as const,
};
